import { Col, Row } from "reactstrap";
import { useAppDispatch } from "../../../../../ReduxToolkit/Hooks";
import { Btn, P } from "../../../../../AbstractElements";
import YearMonthPicker from "../../../../../Component/Forms/FormsControl/YearMonthPicker";
import {
  AddExpense,
  PettyCashExpenseModal,
  primary,
} from "../../../../../utils/Constant";
import { openModal } from "../../../../../ReduxToolkit/Slice/UserProfileDetailsModalSlice";

export interface IHeaderControlsProps {
  selectedMonth: any;
  onChangeMonth: (date: Date) => void;
  centerName: string;
}

const HeaderControls = ({
  selectedMonth,
  onChangeMonth,
  centerName,
}: IHeaderControlsProps) => {
  const dispatch = useAppDispatch();

  return (
    <Row className="align-items-center">
      <Col md="4">
        <P className="m-0 text-nowrap">
          {`${new Date().toLocaleDateString("en-US", {
            month: "long",
            year: "numeric",
          })} Expenses -`}{" "}
          {centerName}
        </P>
      </Col>
      <Col className="mt-3 mt-lg-0" lg="8">
        <Row className="justify-content-end">
          <Col xs="6" md="3" xl="4" xxl="3" className="pe-lg-0">
            <YearMonthPicker
              name="pettyCashPicker"
              classname="petty_cash_year_month_picker"
              placeholder="Select Month"
              onChange={onChangeMonth}
              selectedDate={selectedMonth}
            />
          </Col>
          <Col xs="6" md="3" xl="4" xxl="3" className="ps-lg-0 ms-4">
            <Btn
              color={primary}
              className="m-0"
              onClick={() =>
                dispatch(openModal({ modalType: PettyCashExpenseModal }))
              }
            >
              {AddExpense}
            </Btn>
          </Col>
        </Row>
        <div className="me-4"></div>
        <div className="w-50"></div>
      </Col>
    </Row>
  );
};

export default HeaderControls;
